document.addEventListener('DOMContentLoaded', function () {
    infiniteScroll();
});

function infiniteScroll() {
    var slider = document.querySelector('.announcement-bar ul');
    if (!slider) return;

    var speed = parseFloat(slider.dataset.speed) / 5 || 1;
    var spacing = parseFloat(slider.dataset.spacing);
    var windowWidth = window.innerWidth;

    let clones = Array.from(slider.children).map((child) => child.cloneNode(true));

    if (slider.children.length === 1) {
        clones = Array(2)
            .fill()
            .flatMap(() => clones.map((child) => child.cloneNode(true)));
    }

    clones.forEach((clone) => slider.appendChild(clone));
    let sliderWidth = slider.offsetWidth;

    while (sliderWidth < windowWidth) {
        let clones = Array.from(slider.children).map((child) => child.cloneNode(true));
        clones.forEach((clone) => slider.appendChild(clone));
        sliderWidth = slider.offsetWidth;
    }

    function animate() {
        var firstSlide = slider.firstElementChild;
        if (!firstSlide) return;

        var firstSlideWidth = firstSlide.offsetWidth + spacing;

        firstSlide.style.marginLeft = parseFloat(firstSlide.style.marginLeft || '0') - speed + 'px';

        if (Math.abs(parseFloat(firstSlide.style.marginLeft)) >= firstSlideWidth) {
            firstSlide.style.marginLeft = '0';
            slider.appendChild(firstSlide);
        }

        requestAnimationFrame(animate);
    }

    animate();
}